/**
 * Compact human duration between two ISO timestamps: "37s", "2min 15s", "1h 5min"
 * (unit style matching hoursToTime's "1h 30min"). Clamps to a minimum of "1s" so
 * sub-second or garbage inputs never render "0s"/negative durations.
 */
function formatDurationBetween(startIso, endIso) {
  const seconds = Math.max(
    1,
    Math.round((new Date(endIso) - new Date(startIso)) / 1000) || 1
  );

  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  const restSeconds = seconds % 60;
  if (minutes < 60) {
    return restSeconds ? `${minutes}min ${restSeconds}s` : `${minutes}min`;
  }

  const hours = Math.floor(minutes / 60);
  const restMinutes = minutes % 60;
  return restMinutes ? `${hours}h ${restMinutes}min` : `${hours}h`;
}

export default formatDurationBetween;
